import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context) {
	var base = '.b-mediaListSlider';

	$(base, context).each(function(i, el){
		var slider;

		function initSlider() {
			slider = new Swiper (el.querySelector('.b-mediaListSlider-container'), {
				spaceBetween: 16,
				slidesPerView: "auto",
				navigation: false,
				breakpoints: {
					768: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
				}
			});
		}

		breakpoint(null, 'md')
			.onmatch(function(){
				return initSlider();
			})
			.onmismatch(function() {
				if (slider !== undefined) slider.destroy(true, true);
			});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-mediaListSlider.js
// module id = 19
// module chunks = 0